<template>
  <base-viewer class="grey darken-2">
    <Navbar />
    <v-container class="d-flex align-center" style="height: calc(100% - 77px)">
      <v-row justify="center">
        <router-view />
      </v-row>
    </v-container>
    <Footer />
  </base-viewer>
</template>

<script>
import Footer from "@/core/components/footer";
import Navbar from "./components/navbar";

export default {
  components: {
    Footer,
    Navbar,
  },
};
</script>